import HomeIcon from '@mui/icons-material/Home';

const StashedIcon = HomeIcon;
export default StashedIcon;